import { ClientPage } from "../../submodules/rapdv/client/elements/PagesCtrl"
import { Printer } from "../elements/Printer"

export class PagePrintQrMenu implements ClientPage {
  getPageId = (): string => "print-qr-menu"

  execute = (): void => {
    Printer.printWhenReady()
  }

  onPageClose = (): void => {}
}
